import { useTranslation } from 'react-i18next';

import { StatusDot } from '@/components/ui/custom/StatusDot';
import { cn } from '@/lib/utils';

interface StatusProps {
  status: 'active' | 'inactive';
}

export const Status = ({ status }: StatusProps) => {
  const { t } = useTranslation();
  const isActive = status === 'active';

  return (
    <div className="flex items-center gap-1">
      <StatusDot aria-hidden="true" variant={isActive ? 'successful' : 'neutral'} />
      <span
        className={cn(
          'text-xs leading-4 font-normal',
          isActive ? 'text-text-success-firm' : 'text-foreground-muted'
        )}
      >
        {isActive ? t('rules.active') : t('rules.inactive')}
      </span>
    </div>
  );
};
